<app-lex-xi-modal [isVisible]="isShowing()" maxWidth="720px" (close)="cancel()">
  @if (isShowing()) {
    <ng-template appXIModalContent *transloco="let t; prefix: 'import-dialog'">
      <div class="xi-modal__container import-dashboard__container">
        <div class="xi-modal__title">
          <h2 class="kxi-text-600">{{ title() }}</h2>
          <p [class.import-dashboard__description--minimized]="firstRowContainsDataToggleVisible()">
            {{ description() }}
          </p>

          @if (firstRowContainsDataToggleVisible()) {
            <div class="import-dashboard__container-header-toggle-wrapper">
              <div class="import-dashboard__container-header-toggle">
                <xi-toggle-switch
                  size="normal"
                  [label]="t('toggle-label')"
                  [leftText]="t('toggle-left-text')"
                  [rightText]="t('toggle-right-text')"
                  [changeColorOnToggle]="false"
                  [isLabelInline]="false"
                  (onToggle)="onFirstRowContainsDataToggled($event.detail.isToggled)"
                  [isToggled]="firstRowContainsData()"
                ></xi-toggle-switch>
              </div>
            </div>
          }
        </div>
        <div class="xi-modal__content import-dashboard__file-upload-wrapper">
          <app-file-upload
            [allowedExtensions]="allowedExtensions()"
            [uploadNotes]="uploadNotes()"
            [itemValidator]="itemValidator()"
            [requiresConfirmation]="requiresConfirmation()"
            [notificationType]="notificationType()"
            (fileAdded)="modalClosed.emit($event)"
            (fileConfirmation)="onFileConfirmation($event)"
          ></app-file-upload>
        </div>
      </div>

      @if (filesToConfirm().length) {
        <div class="xi-modal__actions import-dashboard__uploaded-actions">
          <xi-default-button
            [text]="t('cancel')"
            fill="text"
            (onClick)="cancel()"
          ></xi-default-button>
          <xi-default-button [text]="t('select')" (onClick)="confirm()"></xi-default-button>
        </div>
      }
    </ng-template>
  }
</app-lex-xi-modal>
